import { getCurrencySymbol } from '../currency/getCurrencySymbol'

export const customValueFormatter = (params) => {
  return params?.value ?? 'NA'
}

export const customCurrencyValueFormatter = (params) => {
  if (params.value == null) return 'NA'
  const symbol = params.data.currency_code ? getCurrencySymbol(params.data.currency_code) : '$'
  return `${symbol} ${parseFloat(params.value).toFixed(2)}`
}
